import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { createURL } from '@sm/utils';
import { IconCheckCircle } from '@wds/icons';

import EndpageHeader from '~app/components/EndpageHeader';
import RebrandEpFormCore from '~app/components/RebrandEpFormCore';

import PerksIconWhite from '~static/images/icons/perks-icon-white.svg';
import EnterpriseIconWhite from '~static/images/icons/enterprise-icon-white.svg';

const COPY = defineMessages({
  ENDPAGE_HEADER_COPY: {
    id: 'SurveyTaken.BrandedSurveyTaken.EndpageHeaderCopy',
    defaultMessage: 'You have already taken this survey',
    description: '[Type: Header][Vis: med] - Informs the viewer that this survey has been taken',
  },

  PRODUCT_CALLOUT_PERKS_HEADING: {
    id: 'SurveyTaken.BrandedSurveyTaken.ProductCalloutPerksHeader',
    defaultMessage: 'Is your company missing key perks?',
    description:
      '[Type: Header][Vis: med] - Tagline to help entice users to views click the cta below. The CTA leads to another signup page with minimal information.',
  },
  PRODUCT_CALLOUT_PERKS_BODY: {
    id: 'SurveyTaken.BrandedSurveyTaken.ProductCalloutPerkseBody',
    defaultMessage:
      'People love their work perks. Send a survey to find out if you’re offering the incentives employees and potential candidates want.',
    description: '[Type: Paragraph][Vis: med] - Gives context to the above Tagline',
  },
  PRODUCT_CALLOUT_PERKS_CTA: {
    id: 'SurveyTaken.BrandedSurveyTaken.ProductCalloutPerksCTA',
    defaultMessage: 'FIND OUT',
    description: '[Type: Button][Vis: med] - The text for a button which leads users to another sign up page',
  },

  PRODUCT_CALLOUT_ENTERPRISE_HEADING: {
    id: 'SurveyTaken.BrandedSurveyTaken.ProductCalloutEnterpriseHeader',
    defaultMessage: 'Take your business to the next level',
    description: '[Type: Header][Vis: med] - Tagline to help user learn more about SurveyMonkey Enterprise suite',
  },
  PRODUCT_CALLOUT_ENTERPRISE_BODY: {
    id: 'SurveyTaken.BrandedSurveyTaken.ProductCalloutEnterpriseBody',
    defaultMessage:
      'Get access to powerful solutions that help you quickly collect feedback from your customers, prospects, and employees.',
    description: '[Type: Paragraph][Vis: med] - Expands on the above header line.',
  },
  PRODUCT_CALLOUT_ENTERPRISE_CTA: {
    id: 'SurveyTaken.BrandedSurveyTaken.ProductCalloutEnterpriseCTA',
    defaultMessage: 'LEARN MORE',
    description:
      "[Type: Button][Vis: med] - The button text which leads users to a marketing page to learn more about SurveyMonkey's enterprise plans",
  },
});

const BrandedSurveyTaken = () => {
  const utSource = 'survey_taken';
  const utSource2 = 'rebrand_ep_form';

  const CALLOUT_ITEM_SIGN_UP = {
    icon: PerksIconWhite,
    heading: t(COPY.PRODUCT_CALLOUT_PERKS_HEADING),
    copy: t(COPY.PRODUCT_CALLOUT_PERKS_BODY),
    href: createURL('/user/sign-up/', {
      ut_source: utSource,
      ut_source2: utSource2,
    }),
    cta: t(COPY.PRODUCT_CALLOUT_PERKS_CTA),
    ctaColor: 'sabaeus',
    name: 'perks',
  };

  const CALLOUT_ITEM_ENTERPRISE = {
    icon: EnterpriseIconWhite,
    heading: t(COPY.PRODUCT_CALLOUT_ENTERPRISE_HEADING),
    copy: t(COPY.PRODUCT_CALLOUT_ENTERPRISE_BODY),
    href: createURL('/mp/enterprise/', {
      ut_source: utSource,
      ut_source2: utSource2,
    }),
    cta: t(COPY.PRODUCT_CALLOUT_ENTERPRISE_CTA),
    ctaColor: 'midnight',
    name: 'enterprise',
  };

  return (
    <>
      <EndpageHeader copy={t(COPY.ENDPAGE_HEADER_COPY)} icon={<IconCheckCircle aria-hidden="true" title="" />} />
      <RebrandEpFormCore
        utSource={utSource}
        calloutItem1={CALLOUT_ITEM_SIGN_UP}
        calloutItem2={CALLOUT_ITEM_ENTERPRISE}
      />
    </>
  );
};

export default BrandedSurveyTaken;
